import { useRef } from "react";
import SvgDelAttach from "../../consult-form-icons/SvgDelAttach";
import SvgMuteUnmute from "./audio-player-icons/SvgMuteUnmute";
import SvgPlayPause from "./audio-player-icons/SvgPlayPause";
import Range from "./Range";
import useAudioPlayer from "./useAudioPlayer";
import { secondsToMS } from "@/utils/functions/date-time-functions";
import SpinnerForBtn from "@/app/components/lib/loaders/SpinnerForBtn";
interface Props {
  audioUrl: string;
  removeAudio?: () => void | null;
}
const AudioPlayer: React.FC<Props> = ({ audioUrl, removeAudio = null }) => {
  const audioRef = useRef<any>(null);
  const animationRef = useRef<any>(null);

  const {
    playing,
    handlePause,
    handlePlay,
    currentTime,
    duration,
    mute,
    handleMute,
    handleUnmute,
    handleSliderChange,
    canShowDetails,
  } = useAudioPlayer({ audioRef, animationRef });
  return (
    <>
      <audio preload="metadata" ref={audioRef} src={audioUrl} />
      <div className="audio-player">
        {canShowDetails ? (
          <>
            <SvgPlayPause
              play={playing}
              onClick={playing ? handlePause : handlePlay}
            />
            <div className="audio-player-text text-nowrap">
              {secondsToMS(currentTime)}
              {" / "}
              {secondsToMS(duration)}
            </div>
            <Range
              max={duration}
              value={currentTime}
              handleSeekChange={(e) => {
                handleSliderChange(parseFloat(e.target.value));
              }}
              handleSeekMouseUp={undefined}
              handleSeekMouseDown={() => {}}
            />
            <SvgMuteUnmute
              mute={mute}
              onClick={mute ? handleUnmute : handleMute}
            />
            {removeAudio && <SvgDelAttach danger onClick={removeAudio} />}
          </>
        ) : (
          <SpinnerForBtn dark />
        )}
      </div>
    </>
  );
};

export default AudioPlayer;
